import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsOnboardingV2Enabled() {
  return useCbhFlag(CbhFeatureFlag.ENABLE_WORKER_APP_ONBOARDING_V2, {
    defaultValue: { enabled: false, customAddressAutoCompleteEnabled: false },
  });
}
